import * as React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { cn } from "@/lib/utils";

// Restores list/link styling stripped by Tailwind's preflight, since there is
// no typography plugin in this project.
const MARKDOWN_CLASS =
  "text-sm leading-relaxed " +
  "[&_p]:mb-3 [&_ul]:mb-3 [&_ol]:mb-3 [&_ul]:list-disc [&_ol]:list-decimal " +
  "[&_ul]:pl-6 [&_ol]:pl-6 [&_li]:mb-1 [&_a]:text-primary [&_a]:underline " +
  "[&_h1]:mb-2 [&_h1]:font-semibold [&_h1]:text-lg [&_h2]:mb-2 [&_h2]:font-semibold";

const renderExternalLink = ({ href, children }: React.ComponentPropsWithoutRef<"a">) => (
  <a href={href} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
);

interface MarkdownContentProps {
  className?: string;
  markdown?: string | null;
}

export const MarkdownContent = ({ className, markdown }: MarkdownContentProps) => (
  <div className={cn(MARKDOWN_CLASS, className)}>
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ a: renderExternalLink }}>
      {markdown ?? ""}
    </ReactMarkdown>
  </div>
);
